import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../../../../store/marketing/publicador/MarketingPublicador';

import Formsy from 'formsy-react';
import { Row, Label, Modal } from 'react-bootstrap';
import ProgerssBar from '../../../../commons/ProgressBar';
import AlertError from '../../../../commons/AlertError';
import AlertSuccess from '../../../../commons/AlertSuccess';
import AlertInfo from '../../../../commons/AlertInfo';
import TextAreaValidated from '../../../../commons/TextAreaValidated';
import InputSelectValidated from '../../../../commons/InputSelectValidated';
import CurrencyInput from 'react-currency-input';
import BtnSalvar from '../../../../commons/BtnSalvar';
import BtnCancelar from '../../../../commons/BtnCancelar';
import InputTextValidated from '../../../../commons/InputTextValidated';


class ModalOLX extends React.Component {
    constructor() {
        super();
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    async componentDidMount() {
        if (this.props.ModalOLX.showModal) {
            this.props.PublicarVeiculo.dadosPortal.versoes.results = [];
            this.props.PublicarVeiculo.dadosPortal.planos.results = [];
            this.props.PublicarVeiculo.errorText = "";
            this.props.PublicarVeiculo.successText = "";
            this.props.PublicarVeiculo.anuncio.anuncioEmDestaque = false;
            this.props.PublicarVeiculo.anuncio.idAnosModelo = "";
            this.props.PublicarVeiculo.anuncio.idAnuncio = "";
            this.props.PublicarVeiculo.anuncio.idAnuncioCliente = "";
            this.props.PublicarVeiculo.anuncio.idCategoria = 1;
            this.props.PublicarVeiculo.anuncio.idCidade = "";
            this.props.PublicarVeiculo.anuncio.idPublicador = 0;
            this.props.PublicarVeiculo.anuncio.idTipoPlano = "";
            this.props.PublicarVeiculo.anuncio.idTipoAdicional = "";
            this.props.PublicarVeiculo.anuncio.idTipoVeiculo = "";
            this.props.PublicarVeiculo.anuncio.idVeiculo = 0;
            this.props.PublicarVeiculo.anuncio.idVersao = "";
            this.props.PublicarVeiculo.anuncio.preco = 0;
            this.props.PublicarVeiculo.anuncio.precoDe = 0;
            this.props.PublicarVeiculo.anuncio.texto = "";
            this.props.PublicarVeiculo.anuncio.titulo = "";
            this.props.PublicarVeiculo.anuncio.video = "";

            if (this.props.PublicarVeiculo.anuncio.idAnuncioBNDV != null && this.props.PublicarVeiculo.anuncio.idAnuncioBNDV != 0) {
                await this.props.fnBuscarVeiculo();
                await this.props.fnBuscarAnuncio();
                this.props.fnListaVersoes();              
            }
            else {
                this.props.fnBuscarVeiculo();
                this.props.fnListaVersoes();
            }
        }
    }

    handleSubmit(e) {
        if (this.props.PublicarVeiculo.anuncio.idAnuncioBNDV == 0)
            this.props.fnPublicar();
        else
            this.props.fnAlterarAnuncio();
    }

    handleOnHide() {
        this.props.ModalOLX.showModal = false;
        this.props.fnUpdateState(this.props);
    }

    render() {
        var objProps = this.props;

        var dropdownVersoes = [];
        dropdownVersoes.push({ value: '', text: 'Selecione o Versão' });
        objProps.PublicarVeiculo.dadosPortal.versoes.results.forEach(function (entry) {
            dropdownVersoes.push({ value: entry.id, text: entry.Nome });
        });

        return <Modal
            show={this.props.ModalOLX.showModal}
            onHide={this.handleOnHide.bind(this)}
            bsSize="large"
        >
            <Formsy onValidSubmit={this.handleSubmit}>
                <Modal.Header closeButton>
                    <h4 className="modal-title custom-font">Publicar Veículo OLX</h4>
                </Modal.Header>
                <Modal.Body>
                    <AlertInfo
                        textHeader="Atenção! Aviso sobre a OLX!"
                        text={<p>Prezado usuário a OLX pode apresentar inconsistência na publicação de FOTOS. Já reportamos o erro ao portal.</p>}
                        alertVisible={true}
                        onDismiss={() => { }}
                    />
                    <AlertSuccess
                        successText={this.props.PublicarVeiculo.successText}
                        alertVisible={this.props.PublicarVeiculo.successText != '' && this.props.PublicarVeiculo.successText != undefined ? true : false}
                        onDismiss={(alertVisible, successText) => {
                            this.props.PublicarVeiculo.successText = successText;
                            this.props.fnUpdateState(this.props);
                        }}
                    />
                    <AlertError
                        errorText={this.props.PublicarVeiculo.errorText}
                        alertVisible={this.props.PublicarVeiculo.errorText != '' && this.props.PublicarVeiculo.errorText != undefined ? true : false}
                        onDismiss={(alertVisible, errorText) => {
                            this.props.PublicarVeiculo.errorText = errorText;
                            this.props.fnUpdateState(this.props);
                        }}
                    />
                    {
                        this.props.ModalOLX.isLoading
                            ? <ProgerssBar />
                            : <Row>
                                <div className="form-group col-md-5">
                                    <div className="form-group col-md-12 legend">
                                        <h4><strong>Dados Veículo</strong></h4>
                                    </div>
                                    <dl className="dl-horizontal">
                                        <dt>Placa:</dt>
                                        <dd>{this.props.PublicarVeiculo.veiculoBNDV.placa}</dd>
                                        <dt>Chassi:</dt>
                                        <dd>{this.props.PublicarVeiculo.veiculoBNDV.chassi}</dd>
                                        <dt>Marca:</dt>
                                        <dd>{this.props.PublicarVeiculo.veiculoBNDV.descMarca}</dd>
                                        <dt>Modelo:</dt>
                                        <dd>{this.props.PublicarVeiculo.veiculoBNDV.descModelo}</dd>
                                        <dt>Versão:</dt>
                                        <dd>{this.props.PublicarVeiculo.veiculoBNDV.descVersao}</dd>
                                        <dt>Câmbio:</dt>
                                        <dd>{this.props.PublicarVeiculo.veiculoBNDV.descCambio}</dd>
                                        <dt>Combustível:</dt>
                                        <dd>{this.props.PublicarVeiculo.veiculoBNDV.descCombustivel}</dd>
                                        <dt>Portas:</dt>
                                        <dd>{this.props.PublicarVeiculo.veiculoBNDV.descPortas}</dd>
                                        <dt>Cor:</dt>
                                        <dd>{this.props.PublicarVeiculo.veiculoBNDV.cor}</dd>
                                        <dt>Ano Modelo:</dt>
                                        <dd>{this.props.PublicarVeiculo.veiculoBNDV.anoModelo}</dd>
                                        <dt>Ano Fabricação:</dt>
                                        <dd>{this.props.PublicarVeiculo.veiculoBNDV.anoFabricacao}</dd>
                                        <dt>KM:</dt>
                                        <dd>{this.props.PublicarVeiculo.veiculoBNDV.km}</dd>
                                    </dl>
                                    <div className="form-group col-md-12 legend">
                                        <h4><strong>Opcionais</strong></h4>
                                    </div>
                                    <dl className="form-group col-md-12">
                                        <p>{this.props.PublicarVeiculo.veiculoBNDV.opcionais}</p>
                                    </dl>
                                </div>
                                <div className="form-group col-md-7">
                                    <div className="tile-body">
                                        <Row>
                                            <InputTextValidated
                                                name="txtTituloAnuncio"
                                                type="text"
                                                className="col-md-12"
                                                placeholder="Informe o título do anúncio"
                                                onChange={(name, value) => {
                                                    this.props.PublicarVeiculo.anuncio.titulo = value;
                                                    this.props.fnUpdateState(this.props);
                                                }}
                                                value={this.props.PublicarVeiculo.anuncio.titulo}
                                                title="Título do anúncio:"
                                                required
                                            />
                                            <InputSelectValidated
                                                name="ddlVersao"
                                                className="col-md-6"
                                                data={(this.props.PublicarVeiculo.dadosPortal.versoes.isLoading
                                                    ? [{ value: '', text: 'Aguarde carregando...' }]
                                                    : dropdownVersoes)}
                                                onChange={
                                                    (name, value) => {
                                                        this.props.PublicarVeiculo.anuncio.idVersao = value;
                                                        this.props.fnUpdateState(this.props);
                                                    }
                                                }
                                                selectedValue={
                                                    (this.props.PublicarVeiculo.anuncio.idVersao == null)
                                                        ? null
                                                        : this.props.PublicarVeiculo.anuncio.idVersao.toString()
                                                }
                                                value={
                                                    (this.props.PublicarVeiculo.anuncio.idVersao == null)
                                                        ? null
                                                        : this.props.PublicarVeiculo.anuncio.idVersao.toString()
                                                }
                                                title="Versão:"
                                                disabled={this.props.PublicarVeiculo.dadosPortal.versoes.isLoading ? true : false}
                                                required
                                            />
                                            <InputSelectValidated
                                                name="ddlTipoVeiculo"
                                                className="col-md-6"
                                                data={
                                                    [
                                                        { text: 'Selecione o Tipo', value: '' },
                                                        { text: 'Conversível', value: '2' },
                                                        { text: 'Pick-Up', value: '3' },
                                                        { text: 'Antigo', value: '4' },
                                                        { text: 'SUV', value: '5' },
                                                        { text: 'Buggy', value: '6' },
                                                        { text: 'Van/Utilitário', value: '7' },
                                                        { text: 'Sedâ', value: '8' },
                                                        { text: 'Hatch', value: '9' },
                                                    ]
                                                }
                                                onChange={
                                                    (name, value) => {
                                                        this.props.PublicarVeiculo.anuncio.idTipoVeiculo = value;
                                                        this.props.fnUpdateState(this.props);
                                                    }
                                                }
                                                selectedValue={
                                                    (this.props.PublicarVeiculo.anuncio.idTipoVeiculo == null)
                                                        ? null
                                                        : this.props.PublicarVeiculo.anuncio.idTipoVeiculo.toString()
                                                }
                                                value={
                                                    (this.props.PublicarVeiculo.anuncio.idTipoVeiculo == null)
                                                        ? null
                                                        : this.props.PublicarVeiculo.anuncio.idTipoVeiculo.toString()
                                                }
                                                title="Tipo do veículo:"
                                                required
                                            />
                                            <div className="form-group col-md-6">
                                                <label>Valor para anúncio</label>
                                                <CurrencyInput
                                                    decimalSeparator="."
                                                    thousandSeparator=""
                                                    className="form-control"
                                                    id="txtValorAnuncio"
                                                    onChange={(x) => {
                                                        this.props.PublicarVeiculo.anuncio.preco = parseFloat(x);
                                                        this.props.fnUpdateState(this.props);
                                                    }}
                                                    inputType="text"
                                                    value={this.props.PublicarVeiculo.anuncio.preco}
                                                />
                                            </div>
                                            <TextAreaValidated
                                                name="txtDescricao"
                                                className="col-md-12"
                                                placeholder="Informe a descrição do anúncio"
                                                rows={6}
                                                onChange={(name, value) => {
                                                    this.props.PublicarVeiculo.anuncio.texto = value;
                                                    this.props.fnUpdateState(this.props);
                                                }}
                                                value={this.props.PublicarVeiculo.anuncio.texto}
                                                title="Descrição do anúncio:"
                                                required
                                            />
                                            <InputTextValidated
                                                name="txtVideoAnuncio"
                                                type="url"
                                                className="col-md-12"
                                                placeholder="Informe o link do Youtube"
                                                onChange={(name, value) => {
                                                    this.props.PublicarVeiculo.anuncio.video = value;
                                                    this.props.fnUpdateState(this.props);
                                                }}
                                                value={this.props.PublicarVeiculo.anuncio.video}
                                                title="Link do Youtube (Vídeo do Veículo):"
                                            />
                                        </Row>
                                    </div>
                                </div>
                            </Row>
                    }
                </Modal.Body>
                <Modal.Footer>
                    {this.props.PublicarVeiculo.anuncio.idAnuncioBNDV != null
                        && this.props.PublicarVeiculo.anuncio.idAnuncioBNDV != 0
                        ? <BtnCancelar
                            type="button"
                            text=" Remover anúncio"
                            textLoading=" Aguarde..."
                            isLoading={this.props.PublicarVeiculo.isLoading}
                            onClick={() => { this.props.fnRemover(); }}
                        />
                        : null}
                    <BtnSalvar
                        type="submit"
                        text={this.props.PublicarVeiculo.anuncio.idAnuncioBNDV != 0 ? " Alterar Anúncio" : "Publicar Veículo"}
                        textLoading=" Aguarde..."
                        isLoading={this.props.PublicarVeiculo.isLoading}
                    />
                </Modal.Footer>
            </Formsy>
        </Modal >;
    }
}

export default connect(
    state => state.marketing_publicador,
    dispatch => bindActionCreators(actionCreators, dispatch),
    null, {}
)(ModalOLX);